<!--
 * @Date: 2020-08-26 16:46:17
 * @Author: MX
 * @LastEditTime: 2024-01-15 16:52:45
 * @Description: 忘记密码
-->
<template>
  <div class="forgetPassword main-wrap">
    <div class="forgetPassword-title">
      {{ $lang("登录/忘记密码") }}
    </div>
    <div class="forgetPassword-box">
      <div
        class="title"
        :style="{ lineHeight: lang === 'CN' ? '80px' : '118px' }"
      >
        {{ $lang("忘记密码") }}
      </div>
      <div class="form">
        <el-form
          ref="forgetPasswordFormRef"
          :model="forgetPasswordForm"
          :rules="rules"
          id="forgetPassword-form"
          autocomplete="off"
          class="login-form"
        >
          <el-form-item class="type_select">
            <el-radio-group
              v-model="forgetPasswordForm.type"
              size="small"
              @input="typeChenge"
            >
              <el-radio-button label="phone">{{
                $lang("手机")
              }}</el-radio-button>
              <el-radio-button label="email">{{
                $lang("邮箱")
              }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div id="email_form" v-if="forgetPasswordForm.type === 'email'">
            <el-form-item prop="email" class="phoneFormItem">
              <el-input
                :placeholder="$lang('请输入邮箱')"
                v-model="forgetPasswordForm.email"
              >
                <i
                  slot="prefix"
                  class="iconfont icondengluzhuce_youxiang"
                  :class="forgetPasswordForm.email && 'red_color'"
                ></i>
              </el-input>
              <button
                class="sendcodeBtn commonBtn"
                @click.prevent="checkEmail"
                :disabled="isSendCode"
              >
                <span v-if="!isSendCode">{{ $lang("发送") }}</span>
                <span v-else>{{ time }}{{ $lang("秒") }}</span>
              </button>
            </el-form-item>
          </div>
          <div id="phone_form" v-else-if="forgetPasswordForm.type === 'phone'">
            <el-form-item class="phoneFormItem" prop="phone">
              <el-input
                :placeholder="$lang('请输入手机号')"
                v-model="forgetPasswordForm.phone"
              >
                <!-- <i slot="prefix" class="iconfont icondengluzhuce_shouji" :class="forgetPasswordForm.phone && 'red_color'"></i> -->
                <template #prepend>
                  <el-select
                    v-model="forgetPasswordForm.countryCode"
                    :placeholder="$lang('区号')"
                  >
                    <el-option
                      v-for="item in countryCodeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-input>
              <button
                class="sendcodeBtn commonBtn"
                @click.prevent="checkPhone"
                :disabled="isSendCode"
              >
                <span v-if="!isSendCode">{{ $lang("发送") }}</span>
                <span v-else>{{ time }}{{ $lang("秒") }}</span>
              </button>
            </el-form-item>
          </div>
          <el-form-item prop="captcha">
            <el-input
              :placeholder="$lang('请输入验证码')"
              maxlength="10"
              autocomplete="off"
              v-model="forgetPasswordForm.captcha"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_yanzhengma"
                :class="forgetPasswordForm.captcha && 'red_color'"
              ></i>
            </el-input>
          </el-form-item>
          <!-- 防止浏览器的自动记录密码 账号自动输入到验证码处 -->
          <input type="text" style="position: absolute; left: -10000px" />
          <el-form-item prop="password">
            <el-input
              :placeholder="$lang('请输入新密码')"
              maxlength="30"
              name="password"
              autocomplete="new-password"
              :type="isShowPassword ? 'text' : 'password'"
              v-model="forgetPasswordForm.password"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_mima"
                :class="forgetPasswordForm.password && 'red_color'"
              ></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang'
                ]"
                @click="toggleIcon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwordAgain">
            <el-input
              :placeholder="$lang('请再次输入新密码')"
              maxlength="30"
              type="password"
              autocomplete="new-password"
              v-model="forgetPasswordForm.passwordAgain"
            >
              <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
            </el-input>
          </el-form-item>
          <button class="commonBtn cancelBtn" @click.prevent="cancel">
            {{ $lang("取消") }}
          </button>
          <button class="commonBtn submitBtn" @click.prevent="submit">
            {{ $lang("提交") }}
          </button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import * as Api from "@/api";
import { RULES, VALIDATION } from "@/constants/rules";
import { RESPONSE_SUCCESS } from "@/constants";
import debounce from "lodash/debounce";
import { AESUtil } from "@/utils/";
import mixin from "@/mixin/tencentCaptcha";
import { mapGetters } from "vuex";
export default {
  name: "ForgetPassword",
  props: {},
  components: {},
  mixins: [mixin],
  data() {
    return {
      isSendCode: false,
      time: 60,
      codeTimer: null,
      forgetPasswordForm: {
        type: "phone",
        phone: "",
        email: "",
        captcha: "",
        password: "",
        passwordAgain: "",
        countryCode: 966 // 区号
      },
      isShowPassword: false, //不显示
      countryCodeList: [
        {
          label: "+966",
          value: 966
        },
        {
          label: "+971",
          value: 971
        }
      ],
      checkStatus: {
        isLoading: false,
        msg: ""
      }
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    rules() {
      return {
        phone: [RULES.phone, RULES.checkPhone],
        captcha:
          this.forgetPasswordForm.type === "phone"
            ? [RULES.phoneCode]
            : [RULES.emailCode],
        password: [RULES.password, RULES.passwordNew],
        email: [RULES.email, RULES.emailRequired],
        passwordAgain: [{ validator: this.validatePass, trigger: "blur" }]
      };
    }
  },
  mounted() {},
  methods: {
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$lang("请再次输入密码")));
      } else if (value !== this.forgetPasswordForm.password) {
        callback(new Error(this.$lang("两次输入密码不一致!")));
      } else {
        callback();
      }
    },
    typeChenge() {
      this.$nextTick(() => {
        this.$refs.forgetPasswordFormRef.resetFields();
      });
    },
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword;
      console.log(this.isShowPassword);
    },
    /**
     * @description 6.校验手机号
     */
    checkPhone: debounce(function () {
      if (!this.forgetPasswordForm.countryCode) {
        return this.$message.warning(this.$lang("请选择区号"));
      }
      if (!this.forgetPasswordForm.phone) {
        return this.$message.warning(this.$lang("请输入手机号"));
      }
      if (!VALIDATION.phoneNumber.value.test(this.forgetPasswordForm.phone)) {
        return this.$message.warning(this.$lang("请输入正确的手机号"));
      }
      let params = {
        phone:
          this.forgetPasswordForm.countryCode + this.forgetPasswordForm.phone
      };

      Api.checkUserByPhoneOrAccount(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          console.log("手机号没有注册");
          this.$message.error(this.$lang("该手机号尚未注册，请您先注册"));
        } else {
          // 开启验证
          this.captcha.show();
          // this.sendCode()
        }
      });
    }, 500),
    /**
     * @description 7.校验邮箱
     */
    checkEmail: debounce(function () {
      if (!this.forgetPasswordForm.email) {
        return this.$message.warning(this.$lang("请输入邮箱"));
      }
      if (!VALIDATION.email.value.test(this.forgetPasswordForm.email)) {
        return this.$message.warning(this.$lang("请输入正确的邮箱"));
      }
      let params = {
        email: this.forgetPasswordForm.email
      };
      this.checkStatus.isLoading = true;
      this.checkStatus.msg = this.$lang("邮箱效验中，请稍后再试...");
      Api.checkUserByPhoneOrAccount(params).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.error(this.$lang("该邮箱尚未注册，请您先注册"));
        } else {
          // 开启验证
          this.captcha.show();
          // this.sendCode()
        }
      });
    }, 500),
    //发送验证码
    sendCode({ ticket, randstr }) {
      console.log();
      let apiName = "";
      let message = "";
      const httpParams = { ticket, randstr };
      if (this.forgetPasswordForm.type === "phone") {
        apiName = "sendMessage";
        message = "获取手机验证码成功";
        httpParams.countryCode = this.forgetPasswordForm.countryCode;
        httpParams.phone = this.forgetPasswordForm.phone;
        httpParams.type = "reset_pwd";
      } else if (this.forgetPasswordForm.type === "email") {
        apiName = "sendEmail";
        message = "获取邮箱证码成功";
        httpParams.type = 2;
        httpParams.email = this.forgetPasswordForm.email;
      }
      if (apiName) {
        Api[apiName](httpParams).then((res) => {
          if (res.code === RESPONSE_SUCCESS) {
            this.isSendCode = true;
            clearInterval(this.codeTimer);
            this.codeTimer = setInterval(() => {
              this.time--;
              if (this.time === 0) {
                this.isSendCode = false;
                this.time = 60;
              }
            }, 1000);
            this.$message.success(this.$lang(message));
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        console.error("sendCode::", "apiName 不能为空");
      }
    },
    //取消
    cancel() {
      this.$router.push({ path: "/login" });
    },
    /**
     * @description 提交
     */
    submit() {
      this.$refs.forgetPasswordFormRef.validate((valid) => {
        if (valid) {
          const {
            phone,
            captcha,
            password,
            passwordAgain,
            countryCode,
            email
          } = this.forgetPasswordForm;
          const pamrams = {
            phone: countryCode + phone,
            captcha,
            password: AESUtil.aesEncrypt(password),
            passwordAgain: AESUtil.aesEncrypt(passwordAgain),
            email
          };
          Api.resetPwd(pamrams).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              this.$message.success(this.$lang("修改密码成功"));
              this.$router.push({ path: "/login" });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  destroyed() {
    clearInterval(this.codeTimer);
  }
};
</script>

<style lang="scss" scoped>
.forgetPassword {
  position: relative;
  .forgetPassword-title {
    position: absolute;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    color: #4c4d57;
    top: 94px;
    left: 30px;
  }
  .forgetPassword-box {
    .type_select {
      position: absolute;
      top: 0px;
      right: 12px;
    }
    width: 520px;
    height: 550px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .title {
      height: 86px;
      line-height: 86px;
      border-bottom: 1px solid $table-border-color;
      text-align: center;
      font-size: 24px;
      color: #2b2d42;
      font-weight: 600;
    }
    .form {
      padding: 0 100px;
      box-sizing: border-box;
      padding-top: 50px;
      .iconfont {
        font-size: 20px;
        &.red_color {
          color: $theme-color;
        }
      }
    }
    .cancelBtn,
    .submitBtn {
      width: 144px;
      height: 54px;
      background-color: #fff;
      color: #4c4d57;
      margin-top: 8px;
    }
    .submitBtn {
      background-color: $theme-color;
      color: #fff;
      font-size: 18px;
    }
    .cancelBtn {
      margin-right: 32px;
      border: 1px solid #c4c8cc;
      font-size: 18px;
    }
    .phoneFormItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 72px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 10px;
        top: 9px;
        border: 1px solid #c4c8cc;
      }
      &::v-deep {
        .el-input-group__prepend {
          width: 30%;
        }
      }
    }
  }
}
.forgetPassword::v-deep {
  .el-form-item {
    margin-bottom: 30px !important;
  }
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input__suffix {
    right: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
}
</style>
